import React, { useState } from "react";
import PropTypes from "prop-types";
import Accordion from "react-bootstrap/Accordion";
import {Row,Col} from "react-bootstrap"
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import moment from "moment";


const ReferralTableMobile =(props) => {

  
    console.log(props.item)
  return (
    <React.Fragment>
      {/* <SwipeableList className={`swipe`}>
        {({ swipe, ...rest }) => (
          <div className={`${show ? "swipe" : ""}`}>
            <SwipeableListItem
              swipeLeft={{
                content: (
                  <div> */}
                     
                    {/* <div className="sectiontwo d-flex swipeOption">
                      <div className="p-1">
                        <Image
                          alt="wait"
                          title="wait"
                          width="10px"
                          height="13px"
                          src={require("../../../assets/images/UserManagement/wait.svg")}
                        />
                        <div className="f9-400 opacity5">Total Wait time</div>
                        <div className="f10-500">
                          {sendDataDinerProps.diner_status === "NOTSEATED"
                            ? time_convert(minutes)
                            : seated_time_difference(minutesSeated) ||
                              sendDataDinerProps.diner_status === "PENDING"
                            ? time_convert(minutes)
                            : seated_time_difference(minutesSeated)}
                        </div>
                      </div>
                      <div className="sectiontwo-left">
                        {displayButton.diner_status === "NOTSEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="resonFforCancellation"
                              buttonText="Cancel"
                              bigText="Are you sure to Cancel ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          </div>
                        ) : null || displayButton.diner_status === "SEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="seatingUnseated"
                              buttonText="Unseat"
                              bigText="Are you sure to Unseat ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null || displayButton === "pendingReject" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="resonFforCancellation"
                              buttonText="Reject"
                              bigText="Are you sure to Reject ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          </div>
                        ) : null ||
                          displayButton.diner_status === "COMPLETED" ||
                          displayButton.diner_status === "REJECTED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="historyReset"
                              buttonText="Reset"
                              bigText="Are you sure to Reset ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null}
                      </div>

                      <div className="sectionthree-right">
                        {displayButton.diner_status === "NOTSEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="SeatedButton"
                              buttonText="Seat"
                              bigText="Are you sure to Seated ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          </div>
                        ) : null || displayButton.diner_status === "SEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="seatingCompleted"
                              buttonText="Complete"
                              bigText="Are you sure to Completed ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null || displayButtonTwo === "pendingAccept" ? (
                          sendDataDinerProps.service_type === "RESERVATION" ? (
                            sendDataDinerProps.service_type === "RESERVATION" &&
                            date4 < date1.getTime() ? (
                              ""
                            ) : (
                              <DeletePopup
                                buttonDisplay="smallSaveButton"
                                displayPopup="acceptButtonReservation"
                                buttonText="Accept"
                                bigText="Are you sure you want to accept ?"
                                dataSend={sendDataDinerProps}
                              />
                            )
                          ) : sendDataDinerProps.service_type === "SEATING" &&
                            date3 < date1.getDate() ? (
                            ""
                          ) : (
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="acceptButton"
                              buttonText="Accept"
                              bigText="Are you sure you want to accept ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          )
                        ) : // (
                        //   <DeletePopup
                        //     buttonDisplay="smallSaveButton"
                        //     displayPopup="acceptButton"
                        //     buttonText="Accept"
                        //     bigText="Are you sure you want to accept ?"
                        //     dataSend={sendDataDinerProps._id}
                        //   />
                        // )
                        null}
                      </div>
                    </div> */}
                  {/* </div>
                ),
                action: () => setShow(true),
              }}
              swipeRight={{
                // content: <div>Revealed content during swipe</div>,
                action: () => setShow(false),
              }}
              {...rest}
            > */}
              <Card className="main-reusable-accordion">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={props.indexKey + 1}
                eventKey={1}
                >
                  <div className="d-flex align-items-center">
                    <div className="card-header-left" style={{ width: "25%" }}>
                      <div className=" align-items-start">
                        <div className="f9-500">
                            {props.item._id}
                        </div>
                      </div>
                  </div>
                  <div className="card-header-middle f10-500" style={{ width: "33.3333%" }}>
                    <div className="section-one-box">
                        <div className="image-user-box">
                            {/* <Image src={require} alt="User Pic" title="refree User" fluid /> */}
                            <img
                                src={props?.item?.referred_id?.profile_photo}
                                alt="Icon"
                                className="img-fluid rounded-circle"
                                width="10px"
                                height="10px"
                              />
                        </div>
                        <div className="f9-500">
                        {props.item.name}
                        </div>
                        </div>
                        
                    </div>
                    <div
                      className={
                           "card-header-middle"
                      }
                      style={{ width: "25%", textAlign: "center" }}
                    >
                      <div className="d-flex align-items-center" style={{paddingLeft:'30px'}}>
                      <div className="f9-500">
                      {props.item.referred_id_Model}
                        </div>
                      
                      </div>
                    </div>
                    <div
                      className={
                          "card-header-right ml-3 justify-content-end" 
                      }
                      style={{ width: "16.666%" }}
                    >
                      <div className="f9-500">
                            {moment(new Date(props.item.createdAt)).format("Qo MMM YYYY")}
                        </div>
                     
                    </div> 
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse 
                    eventKey={props.indexKey + 1}
                    eventKey={1}
                >
                  <Card.Body>
                    {/******* Section One *********/}
                    <hr className="mt-0" />
                    <div className="row">
                      <div className="col-4 d-flex sectionone-left">
                      <p className="f9-400 pb-2 opacity5">Enrollment Date</p> 
                      <p className="f9-400"><b>{moment(new Date(props.item.enroll_date)).format("Qo MMM YYYY")}</b></p>
                      </div>
                      <div className="col-5 sectionone-middle border-right border-left" style={{marginBottom:'10px'}}>
                        <p className="f9-400 pb-2 opacity5">Referral Qualified</p> 
                        <p className="f9-400"><b></b></p>  
                      </div>
                      <div className="col-3 sectionone-right" style={{marginBottom:'10px'}}>
                        <p className="f9-400 pb-2 opacity5">Amount</p>
                        <p className="f9-400"><b>₹ -</b></p>
                        </div>
                    </div>
                    <hr className="mt-0" />
                    <div className="row">
                      <div className="col-5  sectionone-left border-left" style={{marginBottom:'10px'}}>
                        <p className="f10-400 pb-2 opacity5">Receiving Org ID</p>
                        <p className="f9-400"><b>-</b></p> 
                      </div><br />
                      <div className="col-4 sectionone-middle border-right border-left" style={{marginBottom:'10px'}}>
                        <p className="f10-400 pb-2 opacity5">Receiving Org Name</p>
                        <p className="f9-400"><b>-</b></p>
                      </div><br />
                      
                    </div>
                    
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            {/* </SwipeableListItem> */}
          {/* </div> */}
        {/* )}
      </SwipeableList> */}
    </React.Fragment>
  );
};


// ItemAvailabilityTableBody.propTypes = {
//   auth: PropTypes.object.isRequired,
//   update_item_menu_setup: PropTypes.func.isRequired,
//   get_menu_items: PropTypes.func.isRequired,
//   delete_item_from_category: PropTypes.func.isRequired,
// };

// const mapStateToProps = (state) => ({
//   auth: state.auth,
//   allergy_info: state.category && state.category.allergy_info,
//   menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
//   activeItemId: state.onboarding && state.onboarding.activeItemId,
// });

export default ReferralTableMobile;

// export default connect(mapStateToProps, {
//   update_item_menu_setup,
//   get_menu_items,
//   delete_item_from_category,
// })(ItemAvailabilityTableBody);
